<div class="modal-header">
    <h2 class="modal-title">Purchase Order Line Item</h2>
</div>
<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body">
            <dx-form *ngIf="lineItem" [formData]="lineItem" validationGroup="lineItemValidationGroup">
                <dxi-item itemType="group">
                    <dxi-item dataField="name">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="type" editorType="dxSelectBox" [editorOptions]="{ items: types, onValueChanged: typeChanged }">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="quickBooksAccount" [label]="{ text: 'QuickBooks Account' }" [visible]="lineItem.type === 'Expense'">
                        <dxi-validation-rule type="required"></dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-light" (click)="cancel()">Cancel</button>
</div>
